import { Modal, Box, Typography, Button } from '@mui/material';

interface CloseDisputeDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function CloseDisputeDialog({
  open,
  onClose,
  onConfirm,
}: CloseDisputeDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ zIndex: (theme) => theme.zIndex.modal + 10 }}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: '0 12px 40px rgba(16,35,58,.16)',
          p: 4,
          borderRadius: '14px',
        }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Are you sure you want to close this Dispute and mark it as resolved?
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={onConfirm} color="primary" variant="contained">
            End Dispute
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
